(() => {
  if(customElements.get('fl-weekly-offer'))return;
  class WeeklyOffer extends HTMLElement {
    connectedCallback(){
      this.update();
      const end=Number(this.dataset.end);
      if(Number.isFinite(end)&&Date.now()/1000<end)this.timer=setInterval(()=>this.update(),1000);
    }
    disconnectedCallback(){clearInterval(this.timer);}
    update(){
      const now=Date.now()/1000,start=Number(this.dataset.start),end=Number(this.dataset.end);
      const active=Number.isFinite(start)&&Number.isFinite(end)&&now>=start&&now<end;
      if(!active && now>=end && this.dataset.expiry==='message'){
        this.hidden=false;this.textContent=this.dataset.ended;clearInterval(this.timer);return;
      }
      const wasHidden=this.hidden;
      this.hidden=!active;
      if(this.classList.contains('fl-weekly-strip')&&wasHidden!==this.hidden){
        document.dispatchEvent(new CustomEvent('framelune:offerchange'));
      }
      const countdown=this.querySelector('[data-countdown]');
      if(active && countdown){
        const remaining=Math.max(0,Math.ceil(end-now));
        const days=Math.floor(remaining/86400);
        const hours=Math.floor(remaining%86400/3600);
        const minutes=Math.floor(remaining%3600/60);
        const seconds=remaining%60;
        const clock=[hours,minutes,seconds].map(value=>String(value).padStart(2,'0')).join(':');
        countdown.querySelector('[data-countdown-value]').textContent=`${days}${countdown.dataset.dayUnit||'d'} ${clock}`;
      }
      if(this.hasAttribute('data-hero')){
        const fallback=this.closest('[data-fr-hero-slide]')?.querySelector('[data-weekly-hero-fallback]');
        if(fallback)fallback.hidden=active;
      }
      if(now>=end)clearInterval(this.timer);
      const time=this.querySelector('[data-local-deadline]');
      if(time && !time.dataset.formatted){
        time.textContent=window.FrameLuneTime
          ? window.FrameLuneTime.format(end*1000,document.documentElement.lang,'deadline')
          : new Intl.DateTimeFormat(document.documentElement.lang||'en',{year:'numeric',month:'short',day:'numeric',hour:'numeric',minute:'2-digit',timeZoneName:'short'}).format(new Date(end*1000));
        time.title=`${(document.documentElement.lang||'').startsWith('zh')?'当地时间':'Local time'} · ${Intl.DateTimeFormat().resolvedOptions().timeZone}`;
        time.dataset.timeReady='true';
        time.dataset.formatted='true';
      }
    }
  }
  customElements.define('fl-weekly-offer',WeeklyOffer);
})();
